import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { TREATMENTS } from '../data/content';

// Map treatment id to best matching Cloudinary image
const treatmentImageMap = {
  'acne-pimples':         'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/acne.jpg',
  'eczema-allergy':       'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/eczema.jpg',
  'psoriasis':            'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/psoriosis.jpg',
  'leucoderma':           'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/vitiligo.jpg',
  'hair-fall':            'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/hairfall.jpg',
  'grey-dry-hair':        'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/greyhair.jpg',
  'hair-loss-baldness':   'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/hairloss.jpg',
  'dandruff':             'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/dandruff.jpg',
  'cervical-spondylitis': 'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/spine.jpg',
  'lumbar-spondylitis':   'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/backpain.jpeg',
  'bone-muscular-pain':   'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/bone-n-muscle.jpg',
  'knee-pain-arthritis':  'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/knee.jpg',
  'frozen-shoulder':      'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/frozen-sholder.jpg',
  'sciatica':             'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/scatia.jpg',
  'paralysis':            'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/paraplegia.jpg',
  'migraine':             'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/migrane.jpg',
  'depression-anxiety':   'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/depression.jpg',
  'sinusitis':            'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/sinusitis.webp',
  'asthma-bronchitis':    'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/asthma.webp',
  'obesity':              'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/obsity.jpg',
  'renal-calculi':        'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/renal.jpg',
  'thyroid':              'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/thyroid.jpg',
  'diabetes':             'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/diabetes.jpg',
  'pcod':                 'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/hormones.jpg',
  'piles':                'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/piles-disease.webp',
  'insomnia':             'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/treatments/insomnia.jpg',
};

export default function TreatmentDetail() {
  const { id } = useParams();
  const t = TREATMENTS.find(x => x.id === id);
  const idx = TREATMENTS.indexOf(t);
  if (!t) return <div style={{background:'#1E1108',color:'#F0E6D8',padding:'160px 40px',textAlign:'center'}}><h2>Not found</h2><Link to="/treatments">← Back</Link></div>;
  const img = treatmentImageMap[id] || 'https://ik.imagekit.io/gnzsnmo3fr/vaidyam/therapies/shirodhara.jpg';

  return (
    <div style={{background:'#1E1108',paddingTop:'68px',minHeight:'100vh'}}>
      <Helmet>
        <title>{t.tagline} | Vaidyam Ayurveda Bhopal</title>
        <meta name="description" content={t.desc.slice(0,160)}/>
      </Helmet>

      {/* Hero */}
      <div style={{position:'relative',height:'460px',overflow:'hidden'}}>
        <img src={img} alt={t.name} style={{width:'100%',height:'100%',objectFit:'cover',filter:'brightness(0.28)'}}/>
        <div style={{position:'absolute',inset:0,background:'linear-gradient(to top,#1E1108 0%,transparent 55%)'}}/>
        <div style={{position:'absolute',inset:0,display:'flex',alignItems:'flex-end',padding:'0 48px 52px'}}>
          <div style={{maxWidth:'1280px',margin:'0 auto',width:'100%'}}>
            <Link to="/treatments" style={{fontSize:'12px',color:'rgba(240,230,216,0.35)',display:'inline-flex',gap:'6px',alignItems:'center',marginBottom:'18px',transition:'color 0.2s',textDecoration:'none'}} onMouseEnter={e=>e.currentTarget.style.color='#C8941A'} onMouseLeave={e=>e.currentTarget.style.color='rgba(240,230,216,0.35)'}>← All Treatments</Link>
            <div style={{fontSize:'10px',letterSpacing:'2.5px',color:'#C8941A',textTransform:'uppercase',marginBottom:'10px'}}>{t.seo}</div>
            <h1 style={{fontFamily:'Cormorant Garamond, serif',fontSize:'52px',color:'#F0E6D8',lineHeight:1.1,maxWidth:'680px'}}>{t.tagline}</h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div style={{maxWidth:'1280px',margin:'0 auto',padding:'72px 48px'}}>
        <div style={{display:'grid',gridTemplateColumns:'1fr 320px',gap:'64px'}}>
          <div>
            <h2 style={{fontFamily:'Cormorant Garamond, serif',fontSize:'32px',color:'#F0E6D8',marginBottom:'20px'}}>Understanding {t.name} in Ayurveda</h2>
            <p style={{fontSize:'16px',color:'rgba(240,230,216,0.6)',lineHeight:1.95,marginBottom:'24px'}}>{t.desc}</p>

            <h2 style={{fontFamily:'Cormorant Garamond, serif',fontSize:'28px',color:'#F0E6D8',margin:'36px 0 16px'}}>Root Causes</h2>
            <p style={{fontSize:'15px',color:'rgba(240,230,216,0.55)',lineHeight:1.95,marginBottom:'32px'}}>{t.causes}</p>

            <h2 style={{fontFamily:'Cormorant Garamond, serif',fontSize:'28px',color:'#F0E6D8',marginBottom:'20px'}}>Symptoms We Address</h2>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px',marginBottom:'40px'}}>
              {t.symptoms.map(s=>(
                <div key={s} style={{display:'flex',gap:'12px',alignItems:'center',padding:'13px 16px',background:'#261408',border:'1px solid rgba(255,255,255,0.05)',borderRadius:'2px'}}>
                  <div style={{width:'4px',height:'4px',borderRadius:'50%',background:'#C8941A',flexShrink:0}}/>
                  <span style={{fontSize:'14px',color:'rgba(240,230,216,0.65)'}}>{s}</span>
                </div>
              ))}
            </div>

            <h2 style={{fontFamily:'Cormorant Garamond, serif',fontSize:'28px',color:'#F0E6D8',margin:'36px 0 16px'}}>Dr. Monika's Treatment Protocol</h2>
            <p style={{fontSize:'15px',color:'rgba(240,230,216,0.55)',lineHeight:1.95,marginBottom:'32px'}}>{t.approach}</p>

            <div style={{background:'#261408',border:'1px solid rgba(200,148,26,0.15)',borderRadius:'3px',padding:'24px 28px'}}>
              <div style={{fontFamily:'Cormorant Garamond, serif',fontSize:'22px',color:'#F0E6D8',marginBottom:'10px'}}>Why Choose Vaidyam for {t.name}?</div>
              <p style={{fontSize:'14px',color:'rgba(240,230,216,0.5)',lineHeight:1.85}}>25+ years of Kerala Panchakarma expertise. Authentic Kottakkal & Vaidyaratnam medicines. Classical Charaka Samhita protocols. Central Govt. reimbursement available.</p>
            </div>
          </div>

          {/* Sidebar — NO timings, NO WhatsApp */}
          <div>
            <div style={{background:'#261408',border:'1px solid rgba(255,255,255,0.07)',borderRadius:'3px',padding:'28px',position:'sticky',top:'90px'}}>
              <div style={{fontFamily:'Cormorant Garamond, serif',fontSize:'22px',color:'#F0E6D8',marginBottom:'10px'}}>Book a Consultation</div>
              <p style={{fontSize:'13px',color:'rgba(240,230,216,0.4)',lineHeight:1.7,marginBottom:'22px'}}>Dr. Monika will design a personalised treatment plan — in-person at Bhopal or online.</p>
              <Link to="/book-appointment" className="btn-gold" style={{display:'flex',justifyContent:'center',width:'100%'}}>Book Appointment</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
